var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { formatReportModuleParams, useReport } from '@tencent/dz-report';
export var useReportService = function (questions, type) {
    var report = useReport();
    useEffect(function () {
        recommendExposure();
    }, []);
    var reportParams = {
        module_id: '',
        module_value: questions.join(','),
        module_type: type,
        module_chinese_type: '猜你想问',
        element_chinese_type: '猜你想问',
        element_type: 'guess_question',
        element_content: questions.join(','),
    };
    var reportModuleParams = formatReportModuleParams(reportParams, {});
    var recommendExposure = function () {
        report.exposure(reportParams);
    };
    var recommendClick = function (params) {
        var index = params.index, question = params.question;
        report.click(__assign(__assign({}, reportParams), { element_chinese_type: '问题', element_id: index, element_type: 'question', element_content: question }));
    };
    return {
        recommendExposure: recommendExposure,
        recommendClick: recommendClick,
        reportModuleParams: reportModuleParams,
    };
};
